import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/EmailForm.css';

function EmailForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  // Initialize EmailJS
  useEffect(() => {
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    console.log('EmailJS Init - Public Key:', publicKey ? 'Set' : 'Not set');
    console.log('EmailJS Init - Service ID:', process.env.REACT_APP_EMAILJS_SERVICE_ID ? 'Set' : 'Not set');
    console.log('EmailJS Init - Template ID:', process.env.REACT_APP_EMAILJS_TEMPLATE_ID ? 'Set' : 'Not set');
    console.log('EmailJS Init - Recipient Email:', process.env.REACT_APP_RECIPIENT_EMAIL ? 'Set' : 'Not set');
    
    if (publicKey) {
      emailjs.init(publicKey);
      console.log('EmailJS initialized successfully');
    } else {
      console.error('EmailJS public key not configured. Set REACT_APP_EMAILJS_PUBLIC_KEY environment variable.');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    // Check if all EmailJS configs are set
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const recipientEmail = process.env.REACT_APP_RECIPIENT_EMAIL;

    if (!publicKey || !serviceId || !templateId || !recipientEmail) {
      const missing = [];
      if (!publicKey) missing.push('Public Key');
      if (!serviceId) missing.push('Service ID');
      if (!templateId) missing.push('Template ID');
      if (!recipientEmail) missing.push('Recipient Email');
      
      const errorMsg = `Email service not configured. Missing: ${missing.join(', ')}`;
      console.error(errorMsg);
      setStatus(errorMsg);
      setLoading(false);
      return;
    }

    try {
      console.log('Sending email with:', { serviceId, templateId, recipientEmail });
      
      await emailjs.send(
        serviceId,
        templateId,
        {
          to_email: recipientEmail,
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message
        }
      );

      setStatus('Thank you! Your message has been received. I will get back to you soon!');
      setFormData({ name: '', email: '', message: '' });

      // Clear status after 5 seconds
      setTimeout(() => setStatus(''), 5000);
    } catch (error) {
      console.error('EmailJS Error:', error);
      console.error('Error Details:', error.text || error.message);
      setStatus(`Error: ${error.text || error.message || 'Failed to send email. Please try again later.'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="email-form-container">
      <div className="form-wrapper">
        <h2>Let's get in touch</h2>
        <p className="form-subtitle">Share your doubts and thoughts</p>
        <div className="glass-container">
        <form onSubmit={handleSubmit} className="email-form">
          <div className="form-group">
            <label htmlFor="name">What should I call you? *</label>
            <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Where should I reply? *</label>
            <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Enter your email address"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Tell me everything...</label>
            <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your message here..."
                rows="5"
            ></textarea>
          </div>

          <button
              type="submit"
              className="submit-btn"
              disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Message'}
          </button>

          {status && (
              <div className={`status-message ${status.includes('error') ? 'error' : 'success'}`}>
                {status}
              </div>
          )}
        </form>
        </div>
      </div>
    </section>
  );
}

export default EmailForm;

